export default __webpack_public_path__ + "static/media/undraw_creative_experiment_8dk3.78581405.svg";